import { ApiLine, ApiRouteLine } from "griptonite-api-client";

// Routes embed a slimmer line object than the venue's line list returns.
const toRouteLine = (line: ApiLine): ApiRouteLine => ({
  uuid: line.uuid,
  name: line.name,
  isActive: line.isActive,
  canLead: line.canLead,
  canToprope: line.canToprope,
});
export default toRouteLine;
